export default __webpack_public_path__ + "static/media/pringles_220x1225px.e5c9e9e0.jpg";